import styled from 'styled-components';
import { CaptionMixin, Heading3Mixin } from '@qover/typography';

export const DiscountRow = styled.div`
  ${Heading3Mixin};
  display: flex;
  justify-content: center;

  > div {
    margin-left: 10px;
  }

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    position: relative;
    top: 20px;

    &.static {
      margin-top: 30px;
    }
  }
`;

export const DiscountCodeButton = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-style: italic;

  :hover {
    text-decoration: none;
  }
`;

export const InputContainer = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    max-width: 180px;
  }
`;

export const PromotionText = styled.div`
  ${CaptionMixin};
  letter-spacing: 1px;
  margin-right: 10px;
  text-transform: uppercase;
`;

export const ActionContainer = styled.div`
  &&& {
    margin-top: 3px;
  }
`;

export const SummaryContainer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 450px) {
    && ${ActionContainer} {
      margin-top: -3px;
      margin-left: 10px;
    }
  }
`;

export const DiscountCodeButtonContainer = styled.div`
  margin-top: 3px;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    &.static {
      margin-top: 37px;
    }
    &.my-0 {
      margin-top: 0px;
    }
  }
`;
